(function () {
  var SECTION_SELECTOR = '.ctr-faqs';

  function setOpen(section, activeItem, forceOpen) {
    var items = section.querySelectorAll('[data-ctr-faqs-item]');

    items.forEach(function (item) {
      var shouldOpen = item === activeItem && forceOpen === true;

      item.classList.toggle('is-open', shouldOpen);

      var trigger = item.querySelector('[data-ctr-faqs-trigger]');
      var answer = item.querySelector('[data-ctr-faqs-answer]');

      if (trigger) {
        trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      }

      if (answer) {
        answer.setAttribute('aria-hidden', shouldOpen ? 'false' : 'true');
      }
    });
  }

  function toggleItem(section, item) {
    var isOpen = item.classList.contains('is-open');
    setOpen(section, item, !isOpen);
  }

  function initSection(section) {
    if (!section || section.dataset.ctrFaqsReady === 'true') return;

    section.dataset.ctrFaqsReady = 'true';

    var items = Array.prototype.slice.call(
      section.querySelectorAll('[data-ctr-faqs-item]')
    );

    if (!items.length) return;

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-ctr-faqs-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        toggleItem(section, item);
      });
    });
  }

  function findSection(root) {
    if (!root) return null;
    if (root.matches && root.matches(SECTION_SELECTOR)) return root;
    return root.querySelector ? root.querySelector(SECTION_SELECTOR) : null;
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFaqsReady;
    initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = findSection(event.target);
    if (!section) return;
    delete section.dataset.ctrFaqsReady;
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest
      ? event.target.closest('[data-ctr-faqs-item]')
      : null;
    if (!item) return;

    var section = item.closest(SECTION_SELECTOR);
    if (!section) return;

    setOpen(section, item, true);
  });
})();
